import React, { useEffect, useState } from 'react';

import { Http } from '../../../support';
import Loading from '../../../facturotopia/loading/Loading';
import ProcessCfdiToJsonInputConversion from '../transformers/ProcessCfdiToJsonInputConversion';

const UsePreviousIssuedRetencionInput = (props) => {
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!!props.uuid) {
      handleOnSearch(props.uuid);
    }

    return () => {
      setBusy(false);
    };
  }, [props.uuid]); // eslint-disable-line

  const handleOnSearch = async (cfdiUuid) => {
    try {
      setBusy(true);

      const params = {
        include: 'emisor,receptor,input',
      };

      const response = await Http.get(`/api/retenciones/${cfdiUuid}`, { params });

      let input = response.data.input;

      input.Emisor = response.data.emisor;
      input.Receptor = {
        ...response.data.receptor,
        ...response.data.input.Receptor,
      };

      const data = ProcessCfdiToJsonInputConversion.make(input);

      props.onChange(data);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No fue posible leer tu factura. =(',
      });
    } finally {
      setBusy(false);
    }
  };

  if (busy) {
    return <Loading />;
  }

  return <></>;
};

export default UsePreviousIssuedRetencionInput;
